const CompanyLogo = () => {
  return (
    <>
    <div className="flex justify-center my-9">
    <img className="h-34 my-6 relative" src="/assets/logo-tiki.svg" alt="Logo Tiki"></img>
    </div>
    </>
  )
}

export default CompanyLogo